import { useState } from "react";
import { Icon, LinkButton } from "@ttc3k/trekker";
import { NavArrowRight } from "iconoir-react";
import { AmenitiesPage } from "../OverlayPages";
import { useBookerContext } from "widgets/booker/contexts";
import { PostHogCustomEvent } from "shared/hooks/usePostHog";
import { useWidgetTrack } from "widgets/shared/WidgetTrackingContext";
import { useTranslation } from "react-i18next";

export const ShowAmenities = () => {
  const { product, booker, isEmbedded } = useBookerContext();
  const [openAmenitiesPage, setOpenAmenitiesPage] = useState(false);
  const trackPostHogEvent = useWidgetTrack();

  const { t } = useTranslation("booker", { keyPrefix: "AMENITIES_PAGE" });

  if (
    !product ||
    !product.accommodationMetadata?.amenities ||
    product.accommodationMetadata.amenities.length <= 10
  ) {
    return null;
  }

  const handleShowAmenities = () => {
    setOpenAmenitiesPage(true);
    if (isEmbedded) {
      trackPostHogEvent(PostHogCustomEvent.AmenitiesViewed, {
        productId: product._id,
        bookerId: booker?._id,
      });
    }
  };

  return (
    <>
      <LinkButton justifyContent="flex-start" onClick={handleShowAmenities}>
        {t("BUTTON_LABEL")} <Icon Element={NavArrowRight} />
      </LinkButton>
      <AmenitiesPage
        amenities={product.accommodationMetadata.amenities}
        open={openAmenitiesPage}
        onClose={() => setOpenAmenitiesPage(false)}
      />
    </>
  );
};
